import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function SuperAdminGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-xd-muted">Caricamento…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== "superadmin") return <Navigate to="/admin" replace />;
  return children;
}
